import styled from 'styled-components';
import PaymentHighlight from './PaymentHighlight';
import { PermissionsContext } from '../context/PermissionsContext';
import { HostAppCallbacksContextProvider } from '../context/HostAppCallbacksContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledHighlight = styled.div.withConfig({
  displayName: "PaymentHighlightWrapper__StyledHighlight",
  componentId: "q9nwn2-0"
})(({
  theme
}) => ({
  borderBottom: `1px solid ${theme.color['border-core-default']}`,
  padding: theme.space['600']
}));
const PaymentHighlightWrapper = ({
  objectId,
  permissions,
  onObjectUpdate,
  onObjectDelete,
  auth,
  closeSidebar
}) => {
  return /*#__PURE__*/_jsx(StyledHighlight, {
    children: /*#__PURE__*/_jsx(HostAppCallbacksContextProvider, {
      objectId: objectId,
      onObjectUpdate: onObjectUpdate,
      onObjectDelete: onObjectDelete,
      closeSidebar: closeSidebar,
      children: /*#__PURE__*/_jsx(PermissionsContext.Provider, {
        value: Object.assign({}, permissions, {
          user: auth.user
        }),
        children: /*#__PURE__*/_jsx(PaymentHighlight, {
          objectId: objectId
        })
      })
    })
  });
};
export default PaymentHighlightWrapper;